import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { systemAPI } from '@/utils/api';
import useAppStore from '@/store/appStore';

export function useSystemStatus() {
  const { setAgentStatus } = useAppStore();

  return useQuery({
    queryKey: ['system', 'status'],
    queryFn: async () => {
      const response = await systemAPI.getStatus();
      const data = response.data;

      // Update global store
      setAgentStatus({
        ...data,
        isRunning: data.isRunning !== undefined ? data.isRunning : true,
      });

      return data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });
}

export function useStartAgent() {
  const queryClient = useQueryClient();
  const { addNotification } = useAppStore();

  return useMutation({
    mutationFn: () => systemAPI.start(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['system'] });
      addNotification({
        type: 'success',
        title: 'Agent Started',
        message: 'Email agent started successfully',
      });
    },
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Failed to Start Agent',
        message: error.message,
      });
    },
  });
}

export function useStopAgent() {
  const queryClient = useQueryClient();
  const { addNotification } = useAppStore();

  return useMutation({
    mutationFn: () => systemAPI.stop(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['system'] });
      addNotification({
        type: 'success',
        title: 'Agent Stopped',
        message: 'Email agent stopped successfully',
      });
    },
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Failed to Stop Agent',
        message: error.message,
      });
    },
  });
}

export function useSystemLogs(limit = 100) {
  return useQuery({
    queryKey: ['system', 'logs', limit],
    queryFn: async () => {
      const response = await systemAPI.getLogs(limit);
      return response.data;
    },
  });
}
